'use client'
import React from 'react'

import { useMainStyles } from './styles/main'
import { PageDashboard } from './components/PageDashBoard'
import { FaGlobe, FaExclamationCircle } from 'react-icons/fa'
import { Text, UnstyledButton } from '@mantine/core'
import { NewFeatureCard } from './components/NewFeatures'
import { Footer } from './components/Footer'

// import { Users } from 'tabler-icons-react'

export default function LandingPage() {
  return <LandingPageDetail />
}

const LandingPageDetail = () => {
  const { classes, theme } = useMainStyles()

  // const items = cardData.map((item) => (
  //   <UnstyledButton
  //     key={item.title}
  //     className={classes.item}
  //     onClick={item.onClick}
  //   >
  //     <item.icon color={theme.colors[item.color][6]} size={32} />
  //     <Text size='xs' mt={7}>
  //       {item.title}
  //     </Text>
  //   </UnstyledButton>
  // ))

  return (
    <>
      <main
        style={{
          backgroundColor:
            theme.colorScheme == 'light'
              ? theme.colors.gray[0]
              : theme.colors.dark[9],
        }}
      >
        <PageDashboard />
        <Footer />
      </main>
    </>
  )
}
